import type { Handler } from './handler';
import type {
  ApiFetchSiteStatusPort,
  SiteStatus,
} from './ports/api-fetch-site-status.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

// Igual ao cache do core (30 s): mais curto não traz nada novo.
const CACHE_TTL_MS = 30 * 1000;

let lastGoodResponse: SiteStatus | null = null;
let lastGoodAt = 0;
let inFlight: Promise<SiteStatus | null> | null = null;

// `null` = não deu pra saber agora. Quem chama mantém o que já tem (última
// resposta boa ou o fallback pausado), nunca assume "tudo ligado".
export const fetchSiteStatusHandler: Handler<Params, Ports, Result> = (
  ports = {
    apiFetchSiteStatus: resolveAdapter('apiFetchSiteStatus'),
  },
) => {
  if (lastGoodResponse && Date.now() - lastGoodAt < CACHE_TTL_MS) {
    return Promise.resolve(lastGoodResponse);
  }

  // O plugin crítico, o polling e a volta da aba podem pedir juntos.
  if (inFlight) return inFlight;

  inFlight = (async () => {
    const [status, error] = await tryCatch(ports.apiFetchSiteStatus.handle());

    if (error || !status) {
      console.error('Error fetching site status:', error);

      return null;
    }

    lastGoodResponse = status;
    lastGoodAt = Date.now();

    return status;
  })().finally(() => {
    inFlight = null;
  });

  return inFlight;
};

type Params = undefined;

type Ports = {
  apiFetchSiteStatus: ApiFetchSiteStatusPort;
};

type Result = Promise<SiteStatus | null>;
